import { PagedApiData } from "pmt-types/src/utils/PagedApiData.ts";
import { useInfiniteQuery } from "react-query";
import { Maybe } from "../../utils/types/maybe.ts";
import { useAuthentication } from "../useAuthentication.ts";

type Props = {
  apiRoute: string;
  searchValue: Maybe<string>;
};

export function useInfiniteQueryForApiData<T>({
  apiRoute,
  searchValue,
}: Props) {
  const { accessToken } = useAuthentication();

  const fetchApiData = async ({ pageParam = null }) => {
    const queryParams: { [id: string]: string } = {};

    if (pageParam != null) {
      queryParams["cursor"] = pageParam;
    }

    if (searchValue != null && searchValue !== "") {
      queryParams["name"] = searchValue;
    }

    const response = await fetch(
      `${import.meta.env.VITE_API_HOST}/${apiRoute}?${Object.keys(queryParams)
        .map((key) => `${key}=${queryParams[key]}`)
        .join("&")}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: accessToken ?? "",
        },
      },
    );
    const json = await response.json();

    return json as PagedApiData<T>;
  };

  const queryKey = searchValue == null ? [apiRoute] : [apiRoute, searchValue];

  return useInfiniteQuery(queryKey, fetchApiData, {
    getNextPageParam: (lastPage: PagedApiData<T>) => lastPage.nextCursor,
  });
}
